import React, { useCallback } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import block from 'bem-cn'

import { ROUTE_URLS } from 'router/routes'

import { BonusPromotionStatus } from 'shared/models/Promotion'

import { selectLocaleDict } from 'features/locale/selectors'

import Button from 'components/UIKit/Button/Button'

import './FreeSpinsOver.scss'

const b = block('free-spins-over')

export const FreeSpinsOver: React.FC = () => {
  const history = useHistory()
  const locale = useSelector(selectLocaleDict, shallowEqual).bonuses

  const handlePromotionsClick = useCallback(() => {
    history.push(`${ROUTE_URLS.PROFILE_PROMOTIONS()}?status=${BonusPromotionStatus.active}`)
  }, [history])

  return (
    <div className={b()}>
      <div className={b('header')}>{locale.spinsAreOver}</div>
      <div className={b('text')}>{locale.freeSpinsAreOver}</div>
      <div className={b('button-wrapper')}>
        <div className={b('button')}>
          <Button text={locale.promotions} callback={handlePromotionsClick} />
        </div>
      </div>
    </div>
  )
}
